import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // Deployed builds print nothing to the browser console: hundreds of console.log calls and the
  // LogService (loglevel) would otherwise show customer data, tokens and references in DevTools.
  // LogService still sends its logs to /api/log_process; warnings and errors stay visible.
  const silent = () => undefined;
  console.log = silent;
  console.info = silent;
  console.debug = silent;
  console.trace = silent;
}

// if (environment.log_level == 'debug') {
//   document.write('<script src="https://cdnjs.cloudflare.com/ajax/libs/vConsole/3.15.1/vconsole.min.js"></script>');
// }

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
